import { LanguageProvider } from './contexts/LanguageContext';
import { Navigation } from './components/layout/Navigation';
import { Footer } from './components/layout/Footer';
import { HeroSection } from './components/sections/HeroSection';
import { FeaturesSection } from './components/sections/FeaturesSection';
import { UseCasesSection } from './components/sections/UseCasesSection';
import { ScreenshotsSection } from './components/sections/ScreenshotsSection';
import { FAQSection } from './components/sections/FAQSection';

/**
 * App 主应用组件
 * 
 * 整合所有页面组件，提供完整的落地页体验：
 * - 使用 LanguageProvider 包裹整个应用，提供国际化支持
 * - 按顺序渲染所有内容区域
 * - 为每个 section 添加 id 属性以支持锚点导航
 * - 使用语义化 HTML 标签（header、main、section、footer）
 */
function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        {/* 导航栏 - 固定在页面顶部 */}
        <header>
          <Navigation />
        </header>

        {/* 主内容区域 */}
        <main>
          {/* 英雄区 - 首屏展示 */}
          <section id="hero">
            <HeroSection />
          </section>

          {/* 功能展示区 */}
          <section id="features">
            <FeaturesSection />
          </section>

          {/* 使用场景区 */}
          <section id="use-cases">
            <UseCasesSection />
          </section>

          {/* 产品截图区 */}
          <section id="screenshots">
            <ScreenshotsSection />
          </section>

          {/* 常见问题区 */}
          <section id="faq">
            <FAQSection />
          </section>
        </main>

        {/* 页脚 */}
        <footer>
          <Footer />
        </footer>
      </div>
    </LanguageProvider>
  );
}

export default App;
